import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcSCopyIcon } from '@gem/icons';
import { ButtonTypes, IconButton, IconViewSizes } from '@gem/ui-kit';

import { useCopyToClipboard } from 'APP/hooks/useCopyToClipboard/useCopyToClipboard';

import styles from './CopyToClipboardText.styles.m.css';

interface ICopyToClipboardTextProps {
  text: string;
  toastMessage: string;
  className?: string;
  onCopy?: () => void;
}

export const CopyToClipboardText: FC<ICopyToClipboardTextProps> = observer((props) => {
  const { text, toastMessage, className, onCopy } = props;
  const copyToClipboard = useCopyToClipboard(text, toastMessage, onCopy);

  return (
    <div className={classNames(styles.container, className)}>
      <button
        className={styles.button}
        data-test="copy-text"
        onClick={copyToClipboard}
      >
        {text}
      </button>
      <IconButton
        Icon={IcSCopyIcon}
        onClick={copyToClipboard}
        size={IconViewSizes.Medium}
        type={ButtonTypes.Button}
      />
    </div>
  );
});
